//src/components/App.js

import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import ProductList from "./ProductList";
import ProductDetails from "./ProductDetails";
import NotFound from "./NotFound";
import SearchResults from "./SearchResults";
import Header from "./Header";
import Cart from "./Cart";
import Checkout from "./Checkout";
import OrderConfirmation from "./OrderConfirmation";
import AdminDashboard from "../components/AdminDashboard";
import ErrorBoundary from "./ErrorBoundary";
import Login from "./Login";
import Signup from "./Signup";
import ForgotPassword from "./ForgotPassword";
import ProtectedRoute from "./ProtectedRoute";
import "./App.css";

import { ItemProvider } from "../context/ItemContext";
import { AuthProvider } from "../hooks/useAuth";

const App = () => {
  return (
    <ItemProvider>
      <AuthProvider>
        <BrowserRouter>
          <Header />
          <div className="main-content">
            <ErrorBoundary>
              <Routes>
                <Route path="/" element={<ProductList />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/product/:id" element={<ProductDetails />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route
                  path="/order-confirmation"
                  element={<OrderConfirmation />}
                />
                <Route path="/search" element={<SearchResults />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <AdminDashboard />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </ErrorBoundary>
          </div>
        </BrowserRouter>
      </AuthProvider>
    </ItemProvider>
  );
};

export default App;
